export const articleData = {
  "top-star-secret-romance-exposed": {
    slug: "top-star-secret-romance-exposed",
    title: "顶流明星深夜密会曝光，知情人士爆料已秘密交往一年",
    category: "明星爆料",
    categorySlug: "star-gossip",
    date: "2026-06-28",
    updatedDate: "2026-06-29T10:30:00+08:00",
    views: 128000,
    image: "https://readdy.ai/api/search-image?query=Evening%20urban%20scene%20with%20two%20silhouettes%20walking%20in%20dim%20street%20light%2C%20mysterious%20atmosphere%2C%20paparazzi%20style%20photography%2C%20blurred%20background%20with%20city%20lights%2C%20warm%20evening%20tones%2C%20dramatic%20lighting%2C%20soft%20focus%2C%20candid%20moment%20captured&width=1600&height=900&seq=article-hero-01&orientation=landscape",
    author: "黑料君",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20journalist%20portrait%2C%20Chinese%20male%2C%20warm%20confident%20expression%2C%20soft%20studio%20lighting%2C%20simple%20cream%20background%2C%20editorial%20headshot%2C%20approachable%20look&width=120&height=120&seq=author-01&orientation=squarish",
    excerpt: "据知情人士透露，两位一线明星已秘密交往超过一年，多次被拍到深夜密会。",
    content: [
      {
        type: "paragraph",
        text: "近日，一则关于某顶流明星的恋情爆料在网络上引发热议。据知情人士向本网独家透露，这位顶流男星与圈内某知名女星已秘密交往超过一年，两人多次被拍到深夜相约。",
      },
      {
        type: "paragraph",
        text: "该知情人士表示，两人是在去年的一部大制作电影中相识的，虽然当时并没有对手戏，但在剧组期间就经常一起吃饭，关系迅速升温。电影杀青后，两人依然保持密切联系。",
      },
      {
        type: "heading",
        text: "多次密会被拍，细节曝光",
      },
      {
        type: "paragraph",
        text: "据记者调查，在过去一年中，两人至少被目击到五次深夜密会。最近一次发生在上周三晚间，男星结束工作后直接前往女方位于朝阳区的私人住所，直至次日清晨才离开。",
      },
      {
        type: "paragraph",
        text: "一位不愿透露姓名的圈内人士向记者透露，他们俩其实早就被圈内人默认是一对了，只是在等一个合适的时机公开。两人都很珍惜这段感情，平时非常低调，从不在公共场合同框。",
      },
      {
        type: "heading",
        text: "粉丝反应两极分化",
      },
      {
        type: "paragraph",
        text: "消息传出后，双方粉丝反应呈现两极分化态势。男方粉丝纷纷表示祝福哥哥幸福，而女方部分粉丝则对男方的过往情史表示担忧。社交媒体上相关话题阅读量已突破2亿。",
      },
      {
        type: "paragraph",
        text: "有业内人士分析认为，如果恋情属实且双方选择公开，可能会对两人的商业价值产生不同程度的影响。但从目前来看，两人似乎都选择了保持沉默，既不承认也不否认。",
      },
      {
        type: "heading",
        text: '娱乐圈"秘密恋爱"现象解析',
      },
      {
        type: "paragraph",
        text: '在当今娱乐圈，"秘密恋爱"已经成为一种普遍现象。明星们为了维护个人形象和商业价值，往往选择将感情生活隐藏在聚光灯之外。据不完全统计，近五年来至少有二十对明星情侣在分手后才被证实曾恋爱过。',
      },
      {
        type: "paragraph",
        text: "一位资深娱乐经纪人告诉记者，对于一线明星来说，公开恋情是把双刃剑。一方面可能获得更多关注度和商业机会，另一方面也可能失去部分粉丝和代言。所以很多艺人宁愿选择低调处理私人感情。",
      },
      {
        type: "paragraph",
        text: "本网将持续关注此事进展，为读者带来最新报道。",
      },
    ],
    tags: ["明星恋情", "顶流", "秘密恋爱", "娱乐圈内幕"],
    relatedArticles: [
      "internet-celebrity-scandal-live",
      "variety-show-controversy",
      "actress-divorce-details",
      "endorsement-scandal",
      "plastic-surgery-leak",
    ],
  },

  "internet-celebrity-scandal-live": {
    slug: "internet-celebrity-scandal-live",
    title: "某千万粉丝网红直播翻车，黑历史被扒引发全网热议",
    category: "网红黑料",
    categorySlug: "influencer-gossip",
    date: "2026-06-27",
    updatedDate: "2026-06-28T15:00:00+08:00",
    views: 96000,
    image: "https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20live%20streaming%20interface%20with%20chat%20comments%2C%20dramatic%20red%20and%20dark%20lighting%2C%20social%20media%20drama%20aesthetic%2C%20digital%20screen%20glow%2C%20tense%20atmosphere%2C%20modern%20streaming%20setup%2C%20intense%20mood&width=1600&height=900&seq=article-hero-02&orientation=landscape",
    author: "爆料小助手",
    authorAvatar: "https://readdy.ai/api/search-image?query=Young%20professional%20journalist%20portrait%2C%20Chinese%20female%2C%20friendly%20smile%2C%20clean%20studio%20lighting%2C%20simple%20cream%20background%2C%20editorial%20headshot%2C%20approachable%20look&width=120&height=120&seq=author-02&orientation=squarish",
    excerpt: "知名网红在直播中被网友扒出早年黑历史，直播间弹幕瞬间炸锅。",
    content: [
      {
        type: "paragraph",
        text: "拥有超过1500万粉丝的知名网红在某短视频平台直播时遭遇了职业生涯最大的一次翻车事故。直播进行到一半时，有网友在评论区晒出了该网红早年间的一些争议言论和照片，瞬间引发全场哗然。",
      },
      {
        type: "paragraph",
        text: "据现场观众描述，当黑料被扒出后，直播间弹幕瞬间被刷屏。有人表示脱粉了，也有人为网红辩护说谁没年轻过。网红本人在看到弹幕后表情明显僵硬，随后草草结束了直播。",
      },
      {
        type: "heading",
        text: "黑历史内容曝光",
      },
      {
        type: "paragraph",
        text: "被扒出的黑历史主要包括：五年前在社交平台上的不当言论截图、早期参与某些低俗挑战的视频片段、以及与某些问题主播的私交关系。这些内容在多个平台被迅速转发，相关话题一夜之间冲上热搜。",
      },
      {
        type: "paragraph",
        text: "据业内人士分析，这次黑料集中爆发很可能是有组织的行为。时间点和内容都很可疑，不排除是竞争对手在背后操作的。但他也同时指出，如果那些截图和视频都是真实的，那确实会对网红的形象造成不可逆的损害。",
      },
      {
        type: "heading",
        text: "品牌方纷纷切割",
      },
      {
        type: "paragraph",
        text: "事件发酵后，已有三家品牌方宣布暂停与该网红的合作。其中一家美妆品牌在声明中表示，我们注意到相关情况，正与艺人方进行沟通，后续合作安排将另行公告。",
      },
      {
        type: "paragraph",
        text: "据估算，此次翻车事件可能给该网红带来至少200万元的直接经济损失，品牌合作的中断也将影响其下半年的收入预期。",
      },
      {
        type: "heading",
        text: "网红经济的信任危机",
      },
      {
        type: "paragraph",
        text: "近年来，网红翻车事件频发，从虚假宣传到人设崩塌，再到本次的黑历史被扒，网红经济的信任基础正在经受严峻考验。消费者对网红推荐的信任度已从三年前的67%下降至目前的42%。",
      },
      {
        type: "paragraph",
        text: "一位媒体评论人指出，网红本质上是一种信任经济，一旦信任被打破，重建起来非常困难。这也提醒所有从业者，在追求流量的同时，更需要注重自身形象的长远建设。",
      },
      {
        type: "paragraph",
        text: "截至发稿，该网红尚未对事件作出公开回应。本网将持续关注后续发展。",
      },
    ],
    tags: ["网红翻车", "直播事故", "人设崩塌", "网红经济"],
    relatedArticles: [
      "top-star-secret-romance-exposed",
      "variety-show-controversy",
      "tax-evasion-case",
      "group-conflict",
      "director-reported",
    ],
  },

  "variety-show-controversy": {
    slug: "variety-show-controversy",
    title: "热门综艺录制现场冲突，两位嘉宾因一句玩笑话当场翻脸",
    category: "综艺爆料",
    categorySlug: "show-gossip",
    date: "2026-06-26",
    updatedDate: "2026-06-27T09:00:00+08:00",
    views: 85000,
    image: "https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20bright%20stage%20lights%20and%20empty%20audience%20seats%2C%20two%20chairs%20facing%20each%20other%20on%20stage%2C%20dramatic%20spotlight%20effect%2C%20reality%20show%20aesthetic%2C%20tension%20in%20the%20air%2C%20professional%20studio%20lighting%2C%20behind%20the%20scenes%20vibe&width=1600&height=900&seq=article-hero-03&orientation=landscape",
    author: "综艺观察员",
    authorAvatar: "https://readdy.ai/api/search-image?query=Experienced%20journalist%20portrait%2C%20Chinese%20male%2C%20mature%20confident%20expression%2C%20warm%20studio%20lighting%2C%20simple%20cream%20background%2C%20professional%20editorial%20headshot&width=120&height=120&seq=author-03&orientation=squarish",
    excerpt: "综艺节目录制中两位嘉宾因玩笑话产生误会，现场气氛一度十分尴尬。",
    content: [
      {
        type: "paragraph",
        text: "据现场工作人员向本网独家透露，某档正在热播的真人秀综艺节目在最新一期录制过程中发生了一起意外冲突。两位常驻嘉宾因一句看似无心的玩笑话产生了激烈争执，导致录制被迫中断近两个小时。",
      },
      {
        type: "paragraph",
        text: "据悉，引发冲突的玩笑话涉及其中一位嘉宾的个人隐私，虽然说话方多次强调真的只是开玩笑，但被触及敏感话题的另一位嘉宾明显情绪失控，现场气氛一度十分紧张。",
      },
      {
        type: "heading",
        text: "录制现场还原",
      },
      {
        type: "paragraph",
        text: "根据多位现场工作人员的描述，事情发生在一个互动游戏环节。嘉宾A在游戏中开了一个关于嘉宾B感情生活的玩笑，而嘉宾B最近确实刚刚经历了一段不愉快的感情经历。",
      },
      {
        type: "paragraph",
        text: "嘉宾B当场表示这不好笑，请你尊重一点。随后双方陷入了长达五分钟的尴尬沉默。导演组紧急叫停了录制，将两位嘉宾分别带到不同的休息室进行沟通和安抚。",
      },
      {
        type: "heading",
        text: "节目组紧急公关",
      },
      {
        type: "paragraph",
        text: "事件发生后，节目组迅速启动了危机公关流程。据知情人透露，经过导演组的调解，两位嘉宾最终握手言和，并于当天下午完成了剩余内容的录制。但这次冲突的片段是否会被剪入正片，目前仍是未知数。",
      },
      {
        type: "paragraph",
        text: "有业内人士表示，这种冲突在综艺录制中其实并不罕见，但大多数时候观众是看不到的。节目组通常会选择把这些镜头剪掉，以维护嘉宾的个人形象和节目的和谐氛围。",
      },
      {
        type: "heading",
        text: "综艺节目的边界之争",
      },
      {
        type: "paragraph",
        text: "此次事件也引发了业内人士对综艺节目边界的讨论。随着综艺市场竞争日益激烈，一些节目为了追求话题度和收视率，开始不断突破底线，拿嘉宾的隐私当作笑料。这种做法是否合理，值得整个行业反思。",
      },
      {
        type: "paragraph",
        text: "一位资深综艺导演对此评论道，好的综艺节目应该靠创意和真诚打动观众，而不是靠消费嘉宾的隐私和制造冲突来博眼球。这次事件对所有从业者都是一个警示。",
      },
      {
        type: "paragraph",
        text: "本网已联系涉事双方团队进行求证，截至发稿尚未收到回复。",
      },
    ],
    tags: ["综艺冲突", "录制事故", "真人秀内幕", "综艺节目"],
    relatedArticles: [
      "top-star-secret-romance-exposed",
      "internet-celebrity-scandal-live",
      "director-reported",
      "show-controversy",
      "group-conflict",
    ],
  },

  "actress-divorce-details": {
    slug: "actress-divorce-details",
    title: "知名女星被曝已协议离婚，财产分割细节意外流出",
    category: "明星爆料",
    categorySlug: "star-gossip",
    date: "2026-06-25",
    updatedDate: "2026-06-26T11:00:00+08:00",
    views: 112000,
    image: "https://readdy.ai/api/search-image?query=Elegant%20woman%20silhouette%20walking%20alone%20on%20city%20street%20at%20sunset%2C%20reflective%20mood%2C%20luxury%20handbag%2C%20dramatic%20backlighting%2C%20golden%20hour%20tones%2C%20fashion%20editorial%20style%2C%20melancholic%20atmosphere%2C%20soft%20bokeh%20background&width=1600&height=900&seq=article-hero-04&orientation=landscape",
    author: "黑料君",
    authorAvatar: "https://readdy.ai/api/search-image?query=Professional%20journalist%20portrait%2C%20Chinese%20male%2C%20warm%20confident%20expression%2C%20soft%20studio%20lighting%2C%20simple%20cream%20background%2C%20editorial%20headshot%2C%20approachable%20look&width=120&height=120&seq=author-01&orientation=squarish",
    excerpt: "结婚仅三年的知名女星被曝已与丈夫协议离婚，涉及数亿资产分割。",
    content: [
      {
        type: "paragraph",
        text: "娱乐圈又一对明星夫妻走到了尽头。据多方消息源证实，知名女星林某与丈夫已在本月早些时候签署了离婚协议，正式结束了三年的婚姻关系。消息一出，立即在网络上引发轩然大波。",
      },
      {
        type: "paragraph",
        text: "据接近当事人的知情人士透露，两人早在半年前就已经开始分居，期间经过多次协商，最终和平分手。没有第三者的介入，纯粹是性格不合加上工作聚少离多，感情逐渐淡了。",
      },
      {
        type: "heading",
        text: "数亿资产如何分割",
      },
      {
        type: "paragraph",
        text: "由于女方在婚前就是一线明星，积累了可观的个人财富，而男方同样是一位成功的商人，两人的共同财产数额相当可观。据不完全统计，仅房产一项，两人名下就有北京、上海、三亚、洛杉矶等地的多处豪宅。",
      },
      {
        type: "paragraph",
        text: "知情人士透露，根据离婚协议，女方获得了大部分共同房产和双方名下公司的股权，而男方则保留了自己名下企业的全部所有权。总的来说是一个相对公平的分配方案，双方都做出了让步。",
      },
      {
        type: "heading",
        text: "娱乐圈为何离婚率高",
      },
      {
        type: "paragraph",
        text: "明星离婚在娱乐圈早已不是新闻。据一项统计显示，娱乐圈明星的离婚率高达45%左右，远高于全国平均水平。业内人士分析主要有三大原因：一是聚少离多导致感情淡化；二是娱乐圈诱惑众多；三是明星身份带来的巨大压力和关注度。",
      },
      {
        type: "paragraph",
        text: "一位圈内资深人士感慨道，在娱乐圈谈恋爱容易，但要维持一段长久的婚姻确实很难。明星夫妻承受的压力是普通人难以想象的。",
      },
      {
        type: "paragraph",
        text: "截至目前，双方均未就离婚事件公开发表声明。本网将持续关注后续进展。",
      },
    ],
    tags: ["明星离婚", "财产分割", "婚姻内幕", "娱乐圈"],
    relatedArticles: [
      "top-star-secret-romance-exposed",
      "plastic-surgery-leak",
      "endorsement-scandal",
      "director-reported",
    ],
  },

  "how-to-spot-fake-gossip": {
    slug: "how-to-spot-fake-gossip",
    title: "如何辨别娱乐圈真假黑料？资深娱记教你三招",
    category: "黑料百科",
    categorySlug: "star-gossip",
    date: "2026-06-24",
    updatedDate: "2026-06-25T08:00:00+08:00",
    views: 215000,
    image: "https://readdy.ai/api/search-image?query=Detective%20style%20desk%20with%20magnifying%20glass%20over%20newspaper%20clippings%2C%20warm%20tungsten%20desk%20lamp%20lighting%2C%20vintage%20investigation%20aesthetic%2C%20dark%20wooden%20desk%20surface%2C%20notebooks%20and%20photos%20scattered%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20with%20soft%20shadows&width=1600&height=900&seq=article-hero-encyc-01&orientation=landscape",
    author: "黑料百科编辑部",
    authorAvatar: "https://readdy.ai/api/search-image?query=Experienced%20journalist%20portrait%2C%20Chinese%20male%2C%20mature%20confident%20expression%2C%20warm%20studio%20lighting%2C%20simple%20cream%20background%2C%20professional%20editorial%20headshot&width=120&height=120&seq=author-03&orientation=squarish",
    excerpt: "娱乐圈真假消息满天飞，学会这三招辨别技巧，不再被营销号带节奏。",
    content: [
      {
        type: "paragraph",
        text: "在信息爆炸的时代，娱乐圈的八卦新闻几乎每时每刻都在刷新。但你是否曾经被一条看似真实的爆料骗得团团转，后来才发现是彻头彻尾的假新闻？作为普通吃瓜群众，如何才能练就火眼金睛，在海量信息中辨别真伪？资深娱乐记者老王今天就来分享三招实用的辨别技巧。",
      },
      {
        type: "heading",
        text: "第一招：看信息来源",
      },
      {
        type: "paragraph",
        text: "任何一条八卦新闻，首先要看的是信息来源。正规娱乐媒体的报道通常会标注记者的名字和采访来源。如果一条爆料只有模糊的「据知情人士透露」「网传」「据说」这类模糊表述，却没有具体的人名和职务，那么这条消息的可信度就要大打折扣。",
      },
      {
        type: "paragraph",
        text: "真正靠谱的娱乐新闻，往往会引用多位独立消息源进行交叉验证。如果一个记者能够给出具体的时间、地点和人物关系细节，那么这条消息就相对可信。反之，如果通篇都是「疑似」「可能」「大概」，那基本上就是在编故事。",
      },
      {
        type: "heading",
        text: "第二招：看证据链是否完整",
      },
      {
        type: "paragraph",
        text: "在这个人人都有手机的时代，真正劲爆的八卦往往伴随着照片或视频证据。但如果所谓的爆料只有文字描述，却没有一张实拍照片、一段录音或一个视频作为支撑，那么你就要提高警惕了。",
      },
      {
        type: "paragraph",
        text: "同时也要注意辨别证据的真实性。现在AI技术的发展让造假变得更加容易，深度伪造的图片和视频越来越难以用肉眼辨别。建议关注一些专业的图像鉴定账号，他们会通过技术手段分析图片是否被修改过。另外，如果一个视频的画质忽然变差、画面有明显的拼接痕迹，那也很可能是经过处理的。",
      },
      {
        type: "heading",
        text: "第三招：看时间线和逻辑是否自洽",
      },
      {
        type: "paragraph",
        text: "很多假新闻经不起时间线的推敲。比如一条爆料说某明星在某天晚上在某地做了某事，但你稍微查一下就会发现该明星当天正在外地录制节目，根本不可能出现在爆料所说的地方。",
      },
      {
        type: "paragraph",
        text: "另外，假新闻往往在逻辑上存在明显的漏洞。比如一条爆料说某两位明星正在秘密恋爱，但给出的「证据」却是两人在某个公开活动中的互动——而那个活动明明是商业代言的工作场合。这种强行解读的行为在营销号中十分常见，学会识别这种逻辑漏洞，就能少被带节奏。",
      },
      {
        type: "heading",
        text: "额外建议：建立自己的信息筛选体系",
      },
      {
        type: "paragraph",
        text: "除了以上三招，建立自己的信息筛选体系也很重要。建议关注3-5个公信力较高的娱乐媒体和记者，对他们的报道给予较高的信任权重。对于来源不明的小道消息，一律以「待证实」的态度对待。",
      },
      {
        type: "paragraph",
        text: "最后提醒各位吃瓜群众：理性吃瓜，避免传播未经证实的消息。很多时候，我们在转发一条八卦时的无心之举，可能会对当事人造成难以估量的伤害。吃瓜虽有趣，但也要有底线。",
      },
    ],
    tags: ["黑料百科", "辨别真假", "娱乐新闻", "吃瓜指南", "媒体素养"],
    relatedArticles: [
      "entertainment-industry-unspoken-rules",
      "history-of-gossip-culture",
      "top-star-secret-romance-exposed",
      "internet-celebrity-scandal-live",
      "director-reported",
    ],
  },

  "entertainment-industry-unspoken-rules": {
    slug: "entertainment-industry-unspoken-rules",
    title: "娱乐圈潜规则大揭秘：新人入行必知的那些事",
    category: "黑料百科",
    categorySlug: "industry-insider",
    date: "2026-06-22",
    updatedDate: "2026-06-23T14:00:00+08:00",
    views: 189000,
    image: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20with%20director%20chair%20and%20camera%20equipment%2C%20warm%20studio%20lighting%2C%20professional%20cinematography%20setup%2C%20green%20screen%20background%2C%20movie%20production%20atmosphere%2C%20creative%20workspace%2C%20cinematic%20lighting&width=1600&height=900&seq=article-hero-encyc-02&orientation=landscape",
    author: "黑料百科编辑部",
    authorAvatar: "https://readdy.ai/api/search-image?query=Experienced%20journalist%20portrait%2C%20Chinese%20male%2C%20mature%20confident%20expression%2C%20warm%20studio%20lighting%2C%20simple%20cream%20background%2C%20professional%20editorial%20headshot&width=120&height=120&seq=author-03&orientation=squarish",
    excerpt: "新人入行前必须了解的娱乐圈潜规则，保护自己的同时也能更快适应。",
    content: [
      {
        type: "paragraph",
        text: "娱乐圈表面光鲜亮丽，但背后的运作规则远比普通人想象的复杂。对于刚入行的新人来说，了解这些不成文的规矩，既是保护自己，也是在这个行业生存下去的必修课。本文基于多位资深从业者的访谈，为你揭开娱乐圈的真实面目。",
      },
      {
        type: "heading",
        text: "一、经纪合约的陷阱",
      },
      {
        type: "paragraph",
        text: "新人签约的第一道坎就是经纪合约。很多大型经纪公司会开出看起来很美的条件，但合同条款中往往暗藏玄机。比如超长的合约年限、极低的分成比例、严格的人身限制条款等。一旦签约，艺人几乎完全丧失了自主权。",
      },
      {
        type: "paragraph",
        text: "业内专家建议：签约前一定要请专业律师仔细审查合同，特别注意解约条款、违约金数额和知识产权归属。不要因为急于出道就忽视合同细节，否则很可能陷入长期的合约纠纷。",
      },
      {
        type: "heading",
        text: "二、试镜和选角的真实运作",
      },
      {
        type: "paragraph",
        text: "很多人以为试镜是公平竞争，但现实往往并非如此。在大多数情况下，重要角色在公开试镜之前就已经内定了人选。公开试镜更多是为了满足流程要求和制造话题。真正决定角色归属的，往往是演员背后的资源和人脉。",
      },
      {
        type: "paragraph",
        text: "一位不愿透露姓名的选角导演告诉记者，投资方的意见在选角中占到了60%以上的权重。如果一个演员背后有强大的资本支持或者能够带资进组，那么获得角色的概率会大大增加。",
      },
      {
        type: "heading",
        text: "三、社交媒体时代的公关博弈",
      },
      {
        type: "paragraph",
        text: "在社交媒体时代，艺人的每一个动作都可能成为焦点。这就需要专业的公关团队来进行形象管理。但新人往往不知道，很多所谓的炒作和热搜，背后都有精心策划的脚本。一段随手拍的短视频、一条深夜发的微博，可能都是公关团队的作品。",
      },
      {
        type: "paragraph",
        text: "了解这一点很重要，因为它能帮助新人认清什么是真实的自我，什么是包装出来的人设。过度依赖人设最终都会翻车，只有真实的实力和作品才能长久。",
      },
      {
        type: "heading",
        text: "四、圈内人际关系法则",
      },
      {
        type: "paragraph",
        text: "在娱乐圈，人脉有时候比才华更重要。但这并不意味着要去刻意迎合每一个人。关键是要找准自己的定位，与志同道合的人建立真诚的关系。不要轻信所谓的「前辈提携」，很多表面上的善意背后都有利益交换。",
      },
      {
        type: "paragraph",
        text: "另外，保守秘密是娱乐圈最基本的职业素养。一个管不住嘴的人，无论多有才华，最终都会被圈子排斥。很多看似偶然的翻车事件，其实都是因为有人泄密导致的。",
      },
      {
        type: "paragraph",
        text: "娱乐圈的本质是一个高度商业化的行业，了解这些规则不是为了投机取巧，而是为了更好地保护自己。希望每位新人都能在这个行业中找到属于自己的位置。",
      },
    ],
    tags: ["黑料百科", "娱乐圈潜规则", "新人入行", "经纪合约", "行业揭秘"],
    relatedArticles: [
      "how-to-spot-fake-gossip",
      "history-of-gossip-culture",
      "director-reported",
      "casting-couch-whistleblower",
      "talent-agency-monopoly",
    ],
  },

  "history-of-gossip-culture": {
    slug: "history-of-gossip-culture",
    title: "黑料文化起源：从香港八卦到全民吃瓜的演变史",
    category: "黑料百科",
    categorySlug: "star-gossip",
    date: "2026-06-20",
    updatedDate: "2026-06-21T10:00:00+08:00",
    views: 176000,
    image: "https://readdy.ai/api/search-image?query=Vintage%20Hong%20Kong%20tabloid%20magazine%20rack%20with%20colorful%20covers%2C%20nostalgic%20newsstand%20scene%2C%20warm%20retro%20lighting%2C%20Cantonese%20street%20scene%20background%2C%20old%20school%20aesthetic%2C%20faded%20colors%2C%20cultural%20documentary%20style&width=1600&height=900&seq=article-hero-encyc-03&orientation=landscape",
    author: "黑料百科编辑部",
    authorAvatar: "https://readdy.ai/api/search-image?query=Experienced%20journalist%20portrait%2C%20Chinese%20male%2C%20mature%20confident%20expression%2C%20warm%20studio%20lighting%2C%20simple%20cream%20background%2C%20professional%20editorial%20headshot&width=120&height=120&seq=author-03&orientation=squarish",
    excerpt: "从香港八卦杂志到微博热搜，中国吃瓜文化的三十年变迁。",
    content: [
      {
        type: "paragraph",
        text: "在中国互联网语境中，「吃瓜」已经成为了围观娱乐八卦的代名词。但很少有人知道，这种独特的文化现象是如何一步步演变而来的。从香港街头的八卦杂志，到如今的微博热搜榜，吃瓜文化走过了三十多年的历程。",
      },
      {
        type: "heading",
        text: "第一阶段：香港八卦杂志的黄金时代（1980s-1990s）",
      },
      {
        type: "paragraph",
        text: "上世纪八十年代，香港的八卦杂志迎来了黄金时期。《壹周刊》《东周刊》《忽然1周》等刊物以爆料明星私生活为主要卖点，在香港乃至整个华语地区都拥有巨大的影响力。",
      },
      {
        type: "paragraph",
        text: "那个时代的八卦杂志有着鲜明的特色：耸动的标题、偷拍的照片、夸张的排版。狗仔队文化也在这一时期发展到了巅峰，明星与狗仔之间的追逐战几乎每天都在香港街头真实上演。值得一提的是，当时许多在今天看来稀松平常的新闻报道手法，在当年都引起了巨大的争议。",
      },
      {
        type: "heading",
        text: "第二阶段：互联网BBS时代的萌芽（2000s初）",
      },
      {
        type: "paragraph",
        text: "进入新千年后，随着互联网的普及，天涯社区、猫扑等BBS论坛成为了新一代吃瓜阵地。与纸质媒介不同，网络论坛让普通网友也成为了信息的生产者和传播者，八卦的传播速度和范围都得到了极大的扩展。",
      },
      {
        type: "paragraph",
        text: "天涯社区的「娱乐八卦」板块堪称中国互联网最早的吃瓜圣地。许多后来轰动全网的明星爆料，最初都是在这个板块被网友扒出来的。这个时期也诞生了中国互联网特有的「扒皮文化」——网友们会运用各种手段挖掘公众人物的过往信息。",
      },
      {
        type: "heading",
        text: "第三阶段：微博时代的全民吃瓜（2010s至今）",
      },
      {
        type: "paragraph",
        text: "2009年微博上线后，吃瓜文化进入了一个全新的阶段。实时热搜榜让八卦的传播达到了前所未有的速度，一个重磅爆料可以在几分钟内传遍全网。明星也开始主动利用这一平台与粉丝互动，甚至亲自下场「自曝」。",
      },
      {
        type: "paragraph",
        text: "2016年后，短视频平台的崛起又为吃瓜文化增添了新的维度。抖音、快手上的娱乐账号用几十秒的短视频就能讲完一个八卦，传播效率更高。与此同时，「吃瓜群众」这个词也正式成为了网络流行语。",
      },
      {
        type: "heading",
        text: "未来趋势：AI时代的吃瓜新形态",
      },
      {
        type: "paragraph",
        text: "随着AI技术的快速发展，吃瓜文化也在面临着新的变化。深度伪造技术让真假信息越来越难以辨别，但也推动了信息核实技术的发展。未来，有公信力的娱乐媒体和专业的事实核查机制将变得越来越重要。",
      },
      {
        type: "paragraph",
        text: "回望过去三十年，吃瓜文化从香港街头的报摊走到了每个人的手机屏幕。虽然传播媒介在变，但人们对娱乐八卦的好奇心从未改变。这或许就是吃瓜文化最本质的魅力所在。",
      },
    ],
    tags: ["黑料百科", "吃瓜文化", "八卦历史", "娱乐产业", "媒体变迁"],
    relatedArticles: [
      "how-to-spot-fake-gossip",
      "entertainment-industry-unspoken-rules",
      "top-star-secret-romance-exposed",
      "actress-divorce-details",
      "internet-celebrity-scandal-live",
    ],
  },
};

export const defaultArticles = [
  {
    slug: "how-to-spot-fake-gossip",
    title: "如何辨别娱乐圈真假黑料？资深娱记教你三招",
    category: "黑料百科",
    categorySlug: "star-gossip",
    image: "https://readdy.ai/api/search-image?query=Detective%20style%20desk%20with%20magnifying%20glass%20over%20newspaper%20clippings%2C%20warm%20tungsten%20desk%20lamp%20lighting%2C%20vintage%20investigation%20aesthetic%2C%20dark%20wooden%20desk%20surface%2C%20notebooks%20and%20photos%20scattered%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20with%20soft%20shadows&width=800&height=600&seq=related-encyc-01&orientation=landscape",
    date: "2026-06-24",
    views: 215000,
  },
  {
    slug: "entertainment-industry-unspoken-rules",
    title: "娱乐圈潜规则大揭秘：新人入行必知的那些事",
    category: "黑料百科",
    categorySlug: "industry-insider",
    image: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20with%20director%20chair%20and%20camera%20equipment%2C%20warm%20studio%20lighting%2C%20professional%20cinematography%20setup%2C%20green%20screen%20background%2C%20movie%20production%20atmosphere%2C%20creative%20workspace%2C%20cinematic%20lighting&width=800&height=600&seq=related-encyc-02&orientation=landscape",
    date: "2026-06-22",
    views: 189000,
  },
  {
    slug: "history-of-gossip-culture",
    title: "黑料文化起源：从香港八卦到全民吃瓜的演变史",
    category: "黑料百科",
    categorySlug: "star-gossip",
    image: "https://readdy.ai/api/search-image?query=Vintage%20Hong%20Kong%20tabloid%20magazine%20rack%20with%20colorful%20covers%2C%20nostalgic%20newsstand%20scene%2C%20warm%20retro%20lighting%2C%20Cantonese%20street%20scene%20background%2C%20old%20school%20aesthetic%2C%20faded%20colors%2C%20cultural%20documentary%20style&width=800&height=600&seq=related-encyc-03&orientation=landscape",
    date: "2026-06-20",
    views: 176000,
  },
  {
    slug: "endorsement-scandal",
    title: "大牌明星代言涉嫌虚假宣传，消费者集体维权",
    category: "明星爆料",
    categorySlug: "star-gossip",
    image: "https://readdy.ai/api/search-image?query=Luxury%20beauty%20product%20display%20on%20marble%20counter%2C%20elegant%20packaging%2C%20soft%20studio%20lighting%2C%20cosmetic%20product%20photography%2C%20cream%20and%20gold%20tones%2C%20sophisticated%20aesthetic%2C%20editorial%20style&width=800&height=600&seq=related-05&orientation=landscape",
    date: "2026-06-24",
    views: 132000,
  },
  {
    slug: "plastic-surgery-leak",
    title: "女星整容前后对比照意外流出，本人回应引热议",
    category: "明星爆料",
    categorySlug: "star-gossip",
    image: "https://readdy.ai/api/search-image?query=Beauty%20clinic%20interior%20with%20soft%20pink%20and%20white%20tones%2C%20modern%20minimalist%20aesthetic%2C%20clean%20medical%20setting%2C%20diffused%20natural%20lighting%2C%20elegant%20atmosphere%2C%20spa-like%20environment%2C%20professional%20beauty%20treatment%20room&width=800&height=600&seq=related-07&orientation=landscape",
    date: "2026-06-23",
    views: 105000,
  },
  {
    slug: "director-reported",
    title: "知名导演被多人实名举报，行业震动",
    category: "娱乐圈内幕",
    categorySlug: "industry-insider",
    image: "https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20empty%20movie%20set%2C%20dramatic%20single%20spotlight%2C%20tense%20atmosphere%2C%20professional%20cinema%20equipment%2C%20dark%20studio%20background%2C%20serious%20mood%2C%20behind%20the%20scenes%2C%20cinematic%20lighting&width=800&height=600&seq=related-02&orientation=landscape",
    date: "2026-06-22",
    views: 198000,
  },
  {
    slug: "group-conflict",
    title: "某偶像组合成员内部不和曝光，粉丝站纷纷关站",
    category: "偶像团体",
    categorySlug: "idol-group",
    image: "https://readdy.ai/api/search-image?query=K-pop%20style%20dance%20practice%20room%20with%20mirrored%20walls%2C%20empty%20and%20quiet%2C%20dim%20lighting%2C%20melancholic%20mood%2C%20professional%20dance%20studio%2C%20wooden%20floor%2C%20abandoned%20atmosphere%2C%20emotional&width=800&height=600&seq=related-03&orientation=landscape",
    date: "2026-06-21",
    views: 167000,
  },
  {
    slug: "tax-evasion-case",
    title: "知名主播涉嫌偷税漏税被查，金额或达千万",
    category: "网红黑料",
    categorySlug: "influencer-gossip",
    image: "https://readdy.ai/api/search-image?query=Serious%20legal%20documents%20on%20wooden%20desk%2C%20gavel%20in%20background%2C%20dramatic%20side%20lighting%2C%20professional%20law%20office%20atmosphere%2C%20dark%20wood%20tones%2C%20formal%20and%20weighty%20mood%2C%20editorial%20photography&width=800&height=600&seq=related-08&orientation=landscape",
    date: "2026-06-20",
    views: 98000,
  },
  {
    slug: "show-controversy",
    title: "选秀节目黑幕被前工作人员曝光，官方紧急回应",
    category: "综艺爆料",
    categorySlug: "show-gossip",
    image: "https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20spotlight%20and%20microphone%20stand%2C%20empty%20auditorium%2C%20dramatic%20beam%20of%20light%20from%20above%2C%20competition%20atmosphere%2C%20dark%20surroundings%2C%20theatrical%20mood%2C%20behind%20the%20scenes&width=800&height=600&seq=related-06&orientation=landscape",
    date: "2026-06-19",
    views: 118000,
  },
];